module.exports = __webpack_public_path__ + "static/media/openflow.f23917a9.png";